import React from 'react';
import { Grid } from "@material-ui/core";

const PhysicianGeneralView = ({ physician, selectedTin }) => {
    return (
        <div style={{ width: '100%' }}>
            <Grid
                container
                justifyContent="space-between"
                style={{paddingLeft:"1em"}}
            >
                <Grid item style={{width: "30%"}} justifyContent="left">
                    <h6>First Name:</h6>
                </Grid>
                <Grid item style={{width: "30%"}} justifyContent="left">
                    <h6>Middle Name:</h6>
                </Grid>
                <Grid item style={{width: "30%",marginBottom:'.1em'}} justifyContent="right">
                    <h6>Last Name:</h6>
                </Grid>
            </Grid>
            <Grid
                container
                justifyContent="space-between"
                style={{paddingLeft:"1em",width: "100%",paddingTop:'.15em',marginTop:'-.7em'}}
            >
                <Grid item style={{width: "30%"}} justifyContent="left">
                    <span>{physician.phyFirstName || ''}</span>
                </Grid>
                <Grid item style={{width: "30%"}} justifyContent="left">
                    <span>{physician.phyMiddleName || ''}</span>
                </Grid>
                <Grid item style={{width: "30%"}} justifyContent="right">
                    <span>{physician.phyLastName || ''}</span>
                </Grid>
            </Grid>
            
            <Grid
                container
                justifyContent="space-between"
                style={{paddingLeft:"1em",width: "100%",paddingTop:'.5em'}}
            >
                <Grid item style={{width: "30%"}} justifyContent="left">
                    <h6>Degree(s):</h6>
                </Grid>
                <Grid item style={{width: "30%"}} justifyContent="left">
                    <h6>Date of Birth:</h6>
                </Grid>
                <Grid item style={{width: "30%"}} justifyContent="right">
                    <h6>Gender:</h6>
                </Grid>
            </Grid>
            <div style={{lineHeight:'2em'}}/>
            <Grid
                container
                justifyContent="space-between"
                style={{paddingLeft:"1em",width: "100%",paddingTop:'.15em',marginTop:'-.7em'}}
            >
                <Grid item style={{width: "30%"}} justifyContent="left">
                    <span>{physician.degreeStr || ''}</span>
                </Grid>
                <Grid item style={{width: "30%"}} justifyContent="left">
                    <span>{physician.phyDateOfBirth || ''}</span>
                </Grid>
                <Grid item style={{width: "30%"}} justifyContent="right">
                    <span>{physician.phyGender || ''}</span>
                </Grid>
            </Grid>
            <Grid
                container
                justifyContent="space-between"
                style={{paddingLeft:"1em",width: "100%",paddingTop:'.5em'}}
            >
                <Grid item style={{width: "30%"}} justifyContent="left">
                   <h6>Language(s):</h6>
                </Grid>
                <Grid item style={{width: "30%"}} justifyContent="left">
                    <h6>TIN:</h6>
                </Grid>
                <Grid item style={{width: "30%"}} justifyContent="right">
                   <h6>NPI:</h6>
                </Grid>
            </Grid>
            <div style={{lineHeight:'2em'}}/>
            <Grid
                container
                justifyContent="space-between"
                style={{paddingLeft:"1em",width: "100%",paddingTop:'.15em',marginTop:'-.7em'}}
            >
                <Grid item style={{width: "30%", overflowX:"auto"}} justifyContent="left">
                    <span>{physician.languageStr || ''}</span>
                </Grid>
                <Grid item style={{width: "30%"}} justifyContent="left">
                    <span>{selectedTin || ''}</span>
                </Grid>
                <Grid item style={{width: "30%"}} justifyContent="right">
                    <span>{physician.prvNpi || ''}</span>
                </Grid>
            </Grid>
            <div style={{lineHeight:'2em'}}/>
            <Grid
                container
                justifyContent="space-between"
                style={{paddingLeft:"1em",width: "100%",paddingTop:'.5em'}}
            >
                <Grid item style={{width: "60%"}} justifyContent="left">
                    <h6>LOB:</h6>
                </Grid>
                <Grid item style={{width: "30%"}} justifyContent="right">
                </Grid>
            </Grid>
            <Grid
                container
                justifyContent="space-between"
                style={{paddingLeft:"1em",width: "100%",paddingTop:'.15em',marginTop:'-.7em',paddingBottom:'2em'}}
            >
                <Grid item style={{width: "60%"}} justifyContent="left">
                    <span>{physician.lobString || ''}</span>
                </Grid>
                <Grid item style={{width: "30%"}} justifyContent="right">
                </Grid>
            </Grid>
        </div>
    );
};

export default PhysicianGeneralView;